/* eslint-disable @typescript-eslint/explicit-function-return-type */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({

  //state:コンポーネントでいうdata
  state: {
    settings: {},
    message: '',
    error: '',
    loading: 0,
    confirm: null,
    breadcrumbs: [],
  },

  //getters:コンポーネントでいうcomputed的なもの
  getters: {
    settings(start) {
      return start.settings
    },
    //messageを使用するgetter
    message(state) {
      return state.message
    },
    error(state) {
      return state.error
    },
    loading(state) {
      return 0 < state.loading
    },
    confirm(state) {
      return state.confirm
    },
    breadcrumbs(state) {
      return state.breadcrumbs
    },
  },

  //mutations:コンポーネントでいうmethod（と言うかsetter）
  //stateを唯一変更できるもの
  mutations: {
    //vuexでは引数をpayloadと呼ぶっぽい
    //payloadはオブジェクトにするべき（いっぱい入れれるし）
    setSettings(state, payload) {
      state.settings = payload.settings
    },
    setMessage(state, payload) {
      state.message = payload.message
    },
    setError(state, payload) {
      state.error = payload.error
    },
    updateLoading(state, payload) {
      state.loading += payload
    },
    setConfirm(state, payload) {
      state.confirm = payload.confirm
    },
    setBreadcrumbs(state, payload) {
      state.breadcrumbs = payload.breadcrumbs
    },
  },

  //actionのコミットを使うことでミューテーションを呼び出す（コンポーネントには無い概念）
  actions: {
    setSettings({ commit }, settings) {
      commit('setSettings', { settings })
    },
    setMessage({ commit }, message) {
      commit('setMessage', { message })
    },
    setError({ commit }, error) {
      commit('setError', { error })
    },
    showLoading({ commit }) {
      commit('updateLoading', 1)
    },
    hideLoading({ commit }) {
      commit('updateLoading', -1)
    },
    showConfirm({ commit }, confirm) {
      commit('setConfirm', { confirm })
    },
    hideConfirm({ commit }) {
      commit('setConfirm', { confirm: null })
    },
    setBreadcrumbs({ commit }, breadcrumbs) {
      commit('setBreadcrumbs', { breadcrumbs })
    },
  }
})
